import PropTypes from 'prop-types'
import moment from 'moment'

import { GENDER_SELECT_OPTIONS } from '../../misc/Constants'
import Modal from '../common/Modal'
import AvatarPlaceholder from '../../assets/images/mock/default-profile-icon.png'
import { ReactComponent as CallIcon } from '../../assets/images/common/icons/call-icon.svg'
import { ReactComponent as MailIcon } from '../../assets/images/common/icons/mail-icon.svg'

import classes from './CoachContactInfoModal.module.scss'
import SubmitButton from '../common/buttons/SubmitButton'
import { Link } from 'react-router-dom'

const CoachContactInfoModal = ({ isOpen, onClose, coach }) => {
  const fullName = `${coach.first_name || ''} ${coach.last_name || ''}`.trim()
  const genderLabel = coach.gender !== undefined && coach.gender !== null
    ? GENDER_SELECT_OPTIONS.find(g => g.value === coach.gender)?.label || '-'
    : '-'

  const formatPhoneNumber = (phone, phonePrefix) => {
    if (!phone) { return 'N/A' }

    return phonePrefix ? `${phonePrefix}${phone}` : phone
  }

  const formatLastSignInAt = () => {
    if (!coach.last_sign_in_at) { return 'Never' }

    return moment(coach.last_sign_in_at).format('MM/DD/YYYY')
  }

  const formatBirthday = () => {
    if (!coach.birthdate) { return '-' }

    return moment(coach.birthdate).format('MM/DD/YYYY')
  }

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      className={classes.coachContactInfoModalContent}
    >
      <div className={classes.coachContactInfoModal}>
        <div className='d-flex flex-column mb-5'>
          <h2 className={classes.modalTitle}>Coach Information</h2>
          <p className={classes.modalSubtitle}>
            You cannot edit information for this coach, for security reasons, if they need help you can send them this article&nbsp;
            <a href='https://www.operation36.golf/' target='_blank' rel='noopener noreferrer'>
              link
            </a>
            .
          </p>
        </div>

        <div className='pb-4'>
          <img
            src={coach.avatar?.file_url || AvatarPlaceholder}
            className={classes.coachAvatar}
            alt={`${fullName}'s avatar`}
          />
          <span className='font-weight-bold ml-2'>{fullName}</span>
        </div>

        <div className='d-flex flex-column'>
          <p className='font-weight-bold'>Contact Info</p>

          <div className='d-flex flex-column pb-2'>
            <div className={classes.contactItem}>
              <div className='d-flex justify-content-between align-items-end'>
                <span className={classes.contactText}>{formatPhoneNumber(coach.phone, coach.phone_prefix)}</span>
                <CallIcon className={classes.contactIcon} />
              </div>
            </div>

            <div className={classes.contactItem}>
              <div className='d-flex justify-content-between align-items-end'>
                <span className={classes.contactText}>{coach.email}</span>
                <MailIcon className={classes.contactIcon} />
              </div>
            </div>
          </div>
        </div>

        <div className='d-flex flex-column pb-4'>
          <p className='font-weight-bold'>About</p>

          <p className={classes.aboutItem}>
            Community:&nbsp;
            <Link to={`/communities/${coach.communities[0].id}`} target='_blank' rel='noopener noreferrer'>
              {coach.communities[0].name}
            </Link>
          </p>
          <p className={classes.aboutItem}>
            Gender: {genderLabel}
          </p>
          <p className={classes.aboutItem}>
            Birthday: {formatBirthday()}
          </p>
          <p className={classes.aboutItem}>
            Years in System: {moment(coach.created_at).fromNow(true)}
          </p>
          <p className={classes.aboutItem}>
            Last Signed In At: {formatLastSignInAt()}
          </p>
        </div>

        <div className='d-flex justify-content-center align-items-center'>
          <SubmitButton onClick={onClose} buttonMessage='Got It' className={classes.submitButton} />
        </div>
      </div>
    </Modal>
  )
}

CoachContactInfoModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  coach: PropTypes.object,
}

export default CoachContactInfoModal
